$(document).ready(function(){
    $('#titleBar .toggle').on('click', function () {
        if ($("#navPanel").width() == 0){
           $('#titleBar').css('transform', 'translate(280px, 0px)');
           $('.header-toggle').css('transform', 'translate(0px, 0px)');
           $('.header-toggle').css('z-index', '10001');
           $('#navPanel').css('z-index', '10002');
           $('#navPanel').css('width', '280px');
        }
        else {
            $('#titleBar').css('transform', 'translate(0px, 0px)');
            $('.header-toggle').css('transform', 'translate(0px, 0px)');
            $('.header-toggle').css('z-index', 'auto');
            $('#navPanel').css('width', '0px');
        }
    });
});

$(document).on('click', function(event) {
  if (($("#navPanel").width() !== 0) && ($(event.target).closest('#navPanel').length === 0)){
    $('#navPanel').css('width', '0px');
    $('#titleBar').css('transform', 'translate(0px, 0px)');
    $('.header-toggle').css('transform', 'translate(0px, 0px)');
    $('.header-toggle').css('z-index', 'auto');
  }
});

var mobileBasket = '.mobile__nav-basket';

$(document).on('click', mobileBasket, function(e){
  e.preventDefault();
  $(this).parent().toggleClass('opened');
});

var basketLink = '.nav__basket-link',
    basketHover = '.nav__basket-hover-block',
    basketPreview = '.nav__shopping-cart-preview-block';

$(document).on('mouseover', basketPreview, function(){
  $(basketHover).show('fast');
  $(basketLink).addClass('border-on-hover');
});

$(document).on('mouseleave', basketPreview,function(){
  $(basketHover).hide('fast');
  $(basketLink).removeClass('border-on-hover');
});

$(document).ready(function() {
  $('.hero__slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 2000,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 3000
  });
});